var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowlefT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 7.49993C18.0003 7.69884 17.9213 7.88961 17.7806 8.03026C17.64 8.17091 17.4492 8.24993 17.2503 8.24993H2.5606L8.03091 13.7193C8.10059 13.789 8.15587 13.8717 8.19358 13.9628C8.23129 14.0538 8.2507 14.1514 8.2507 14.2499C8.2507 14.3485 8.23129 14.4461 8.19358 14.5371C8.15587 14.6281 8.10059 14.7109 8.03091 14.7806C7.96123 14.8502 7.8785 14.9055 7.78746 14.9432C7.69641 14.9809 7.59883 15.0003 7.50029 15.0003C7.40174 15.0003 7.30416 14.9809 7.21311 14.9432C7.12207 14.9055 7.03934 14.8502 6.96966 14.7806L0.21966 8.03055C0.149927 7.9609 0.0946083 7.87818 0.056865 7.78713C0.0191218 7.69609 -0.000305176 7.59849 -0.000305176 7.49993C-0.000305176 7.40137 0.0191218 7.30377 0.056865 7.21272C0.0946083 7.12168 0.149927 7.03896 0.21966 6.9693L6.96966 0.219304C7.11039 0.0785732 7.30126 -0.000488283 7.50029 -0.000488281C7.69931 -0.00048828 7.89018 0.0785732 8.03091 0.219304C8.17164 0.360034 8.2507 0.550906 8.2507 0.749929C8.2507 0.948952 8.17164 1.13982 8.03091 1.28055L2.5606 6.74993H17.2503C17.4492 6.74993 17.64 6.82895 17.7806 6.9696C17.9213 7.11025 18.0003 7.30102 18.0003 7.49993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowlefT);
export default __webpack_public_path__ + "static/media/arrowlefT.8a19e1e3fb25b94400b9efd3020de131.svg";
export { ForwardRef as ReactComponent };